import { ImageAssetItem } from '../images/image-asset-item.model';
import { AppTeamUtil } from '../../core/app-team-util';

export class OrganizationRolloverLogItem
{
	constructor(json: any = null)
	{
		if (json)
		{
			Object.assign(this, json);
			this.LoggedAt = AppTeamUtil.convertApiDateStringToDate(json['LoggedAt'])!;
		}
	}

	Area!: string;
	Action!: string;
	EntityId?: number;
	Name!: string;
	YearOld!: number;
	YearNew!: number;
	Details?: string;
	LoggedAt!: Date;
}

export class OrganizationRolloverResult
{
    Info!: string;
	Logs: OrganizationRolloverLogItem[] = [];

    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
	        if (json.Logs) this.Logs = json.Logs.map((json: any) => new OrganizationRolloverLogItem(json));
        }
    }
}
